import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  stepperContainer: {
    margin: '0 auto',
    maxWidth: 900,
  },
  content: {
    margin: '0 auto',
    maxWidth: 700,
  },
}));

export default useStyles;
